import styled from 'styled-components';

export const hiddenFn = ({ hidden }) => (hidden ? 'hidden' : 'block');
export const Toggler = styled.div`
  display: ${hiddenFn}
`;

Toggler.displayName = 'Toggler';
